function initSlider() {
    // //Product page option frames changer
    // $('.option-framing label').on('click',function(){
    //     $('.main-product-gallery div:not(.other) .card__media').css('background-image', "url(" +  $('.option-framing #' + $(this).attr('for')).data('url') + ")");
    // });
    // if ($('.option-framing input:checked').length > 0) {
    //     $('.main-product-gallery div:not(.other) .card__media').css('background-image', "url(" +  $('.option-framing input:checked').data('url') + ")");
    // }

    // //Product page option frames size wall preview
    // $('.option-print-size label').on('click',function(){
    //     $('.main-product-gallery .slide-wall-preview').attr('data-frame-size',  $('.option-print-size #' + $(this).attr('for')).data('frame-size'));
    // });
    // if ($('.option-print-size input:checked').length > 0) {
    //     $('.main-product-gallery .slide-wall-preview').attr('data-frame-size',  $('.option-print-size input:checked').data('frame-size'));
    // }

    

    if ($('.main-product-gallery').length > 0) {
      setTimeout(function(){
        //Product page main slider
        $('.main-product-gallery').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: false, 
            dots: true,           
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        dots: true
                    }
                }
            ]
        });
        
      }, 50);
    }

    
}


function cartDrawerQuickView(productHandle) {
    const upsellMainContent = document.querySelector('.drawer__upsell-main');
    const quickShopDrawer = document.querySelector('.quickshop-drawer');
    const currentItemHandle = upsellMainContent.dataset.handle;
    if(productHandle === currentItemHandle) {
        quickShopDrawer.classList.add('active');
    } else {
        fetch(`/products/${productHandle}?view=cart-upsell`)
            .then((response) => response.text())
            .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            console.log(responseHTML);
            
            upsellMainContent.innerHTML = responseHTML.querySelector('.drawer__upsell-main').innerHTML;
            quickShopDrawer.classList.add('active');
            upsellMainContent.setAttribute('data-handle', productHandle);
            
            $('.option-frame-color').find('input:checked+label').trigger('click');

            })
            .finally(() => {
                setTimeout(initSlider(), 100);
            
            });    
    }
}